`<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">功德徵信</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">首頁</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'financial-disclosures' }">功德徵信</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <b-form @submit="submitParam">
          <b-input-group size="lg">
            <b-input-group-prepend>
              <b-input-group-text style="border-color: black;">
                <strong style="color: blue">查詢</strong>
              </b-input-group-text>
            </b-input-group-prepend>
            <b-form-select
              v-model="filter.of_year"
              style="border-color: black; color: black"
              size="lg"
            >
              <b-form-select-option value="">年份</b-form-select-option>
              <b-form-select-option :value="n" v-for="n in years">{{ n }}年</b-form-select-option>
            </b-form-select>
            <b-form-select
              v-model="filter.of_month"
              style="border-color: black; color: black"
              size="lg"
            >
              <b-form-select-option value="">月份</b-form-select-option>
              <b-form-select-option :value="n" v-for="n in 12">{{ n }}月</b-form-select-option>
            </b-form-select>
            <b-input-group-append>
              <b-button type="submit" variant="primary">搜尋</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>
    </div>
    <b-overlay :show="is_loading" rounded="sm" opacity="0.6">
      <div class="row mt-3" v-for="financial_statement in financial_statements">
        <div class="col">
          <div class="row">
            <div class="col">
              <b-button
              variant="outline-primary"
              target="_blank"
              :href="financial_statement.donor_list.attachments[0].url"
              v-if="financial_statement.donor_list && financial_statement.donor_list.attachments.length > 0"
            >{{ financial_statement.year }}年{{ financial_statement.month }}月功德芳名</b-button>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <h3>{{ financial_statement.year }}年{{ financial_statement.month }}月資金收支表</h3>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <b-table
                fixed
                striped
                stacked="lg"
                sortBy="sequence_number"              
                :fields="fields"
                :items="financial_statement.details"
              >
                <template v-slot:custom-foot>
                  <b-tr>
                    <b-td>&nbsp;</b-td>
                    <b-td>合計</b-td>
                    <b-td>{{ financial_statement.previous_balance_amount }}</b-td>
                    <b-td>{{ financial_statement.income_amount }}</b-td>
                    <b-td>{{ financial_statement.expense_amount }}</b-td>
                    <b-td>{{ financial_statement.balance_amount }}</b-td>
                  </b-tr>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <b-pagination
            v-model="page"
            :total-rows="total"
            :per-page="per_page"
            @change="pageChange"
            align="center"
            size="lg"
          ></b-pagination>
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <b-icon icon="arrow-clockwise" font-scale="5" animation="spin-pulse"></b-icon>
        </div>
      </template>
    </b-overlay>
  </div>
</template>
<script>
import Vue from 'vue'
import lodash from 'lodash'

import { stringify } from 'query-params-helpers'
import { BreadcrumbPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { FormPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { IconsPlugin } from 'bootstrap-vue'
import { InputGroupPlugin } from 'bootstrap-vue'
import { TablePlugin } from 'bootstrap-vue'
import { OverlayPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'

import DonorListApiService from '@/services/budaedu-api-services/donor-list-api-service.js'
import FinancialStatementApiService from '@/services/budaedu-api-services/financial-statement-api-service.js'

Vue.use(lodash)
Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormPlugin)
Vue.use(FormSelectPlugin)
Vue.use(IconsPlugin)
Vue.use(InputGroupPlugin)
Vue.use(OverlayPlugin)
Vue.use(PaginationPlugin)
Vue.use(TablePlugin)

Vue.use(DonorListApiService)
Vue.use(FinancialStatementApiService)

export default {
  name: 'financial-disclosures',
  props: {
    // 
  },
  data() {
    return {
      is_loading: false,
      filter: {
        of_year: '',
        of_month: ''
      },
      years: [],
      fields: [
        { key: 'sequence_number', label: '序' },
        { key: 'name', label: '項目' },
        { key: 'previous_balance_amount', label: '上月結餘' },
        { key: 'income_amount', label: '本月收入' },
        { key: 'expense_amount', label: '本月支出' },
        { key: 'balance_amount', label: '本月結餘' }
      ],
      per_page: 1,
      page: 1,
      total: 0,
      financial_statements: []
    }
  },
  methods: {
    submitParam(event) {
      event.preventDefault()
      this.page = 1
      this.setFinancialStatementsAndPaging()
    },
    pageChange(page) {
      this.page = page
      this.setFinancialStatementsAndPaging()
    },
    async setYears() {
      this.years = await this.$financialStatementApiService.getListOfYear()
    },
    async setFinancialStatementsAndPaging() {
      this.is_loading = true
      this.financial_statements = []
      try {
        let params = stringify({
          include: 'details',
          filter: lodash.pickBy(this.filter, value => value !== ''),
          per_page: this.per_page,
          page: this.page,
          order: 'year,desc|month,desc'
        }).substr(1)
        const items = await this.$financialStatementApiService.query(params)

        const previewPromises = items.data.map(async (item) => {
          let params = stringify({ include: 'attachments' }).substr(1)
          const data = await this.$donorListApiService.getByYearAndMonth(item.year, item.month, params)
          if (data) {
            item.donor_list = data
          }
        })
        await Promise.all(previewPromises)

        this.financial_statements = items.data
        this.total = items.meta.total
        // console.log(this.financial_statements)
      } finally {
        this.is_loading = false
      }
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    await this.setFinancialStatementsAndPaging()
    await this.setYears()
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: '功德徵信',
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>